import { Trans } from '@lingui/react';
import styled from 'styled-components';
import { Box, Container } from '@components/layout/Grid';
import SimpleAccordionList from '@organisms/SimpleAccordionList';
import SectionHeader from '@components/SectionHeader';

const FAQContainer = styled(Container)`
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;

  .SectionHeader--H2SectionHeader {
    font-size: 18px;
    font-weight: 500;
  }
`;

const FAQWrapper = styled(Box)`
  max-width: 1024px;
  margin: 0 auto;
`;

const FAQ = [
  {
    title: <Trans id="programs_listing.faq.item1.title" />,
    body: <Trans id="programs_listing.faq.item1.body" />,
  },
  {
    title: <Trans id="programs_listing.faq.item2.title" />,
    body: (
      <Trans
        id="programs_listing.faq.item2.body"
        components={[
          <a
            key="0"
            href="https://yogobe.com/se/me/dashboard"
            target="_blank"
            rel="noreferrer"
          ></a>,
        ]}
      />
    ),
  },
  {
    title: <Trans id="programs_listing.faq.item3.title" />,
    body: <Trans id="programs_listing.faq.item3.body" />,
  },
  {
    title: <Trans id="programs_listing.faq.item4.title" />,
    body: (
      <>
        <Trans id="programs_listing.faq.item4.body" />
        <br />
        <br />
        <Trans id="programs_listing.faq.item4.body2" />
      </>
    ),
  },
  {
    title: <Trans id="programs_listing.faq.item5.title" />,
    body: (
      <Trans
        id="programs_listing.faq.item5.body"
        components={[
          <a
            key="0"
            href="mailto:business@yogobe.com"
            target="_blank"
            rel="noreferrer"
          ></a>,
        ]}
      />
    ),
  },
  {
    title: <Trans id="programs_listing.faq.item6.title" />,
    body: <Trans id="programs_listing.faq.item6.body" />,
  },
  {
    title: <Trans id="programs_listing.faq.item7.title" />,
    body: (
      <Trans
        id="programs_listing.faq.item7.body"
        components={[
          <a
            key="0"
            href="https://yogobe.com/se/register/account"
            target="_blank"
            rel="noreferrer"
          ></a>,
          <a
            key="1"
            href="https://yogobe.com/se/blog/wellnet-actiway-benify-friskvardsbidrag"
            target="_blank"
            rel="noreferrer"
          ></a>,
          <a
            key="2"
            href="https://yogobe.com/se/me/settings/subscriptions"
            target="_blank"
            rel="noreferrer"
          ></a>,
        ]}
      />
    ),
  },
];

const FAQSection = ({ faq = FAQ }) => {
  return (
    <FAQContainer id="faq" flexDirection="column" mt={[-20, 0, 0]} py={40}>
      <FAQWrapper mb={[25]} mx="auto">
        <SectionHeader
          title={<Trans id="metadata.frequently_asked_questions.title" />}
        />
        <SimpleAccordionList list={faq} />
      </FAQWrapper>
    </FAQContainer>
  );
};

export default FAQSection;
